import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, CircularProgress, Typography, FormControl, Divider } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { detectBrowserLanguageCode, withBrowserLanguageOnTop } from "../sc-translate/appTranslations";

const styles = theme => ({
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%",
        marginBottom: '5px'
    }
});

const EmailAuthenticationForm = (props) => {
    const { classes, formSettings, initialValues, handleSubmit, handleLanguageChange, appTranslations, translations, } = props;

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue } = formikProps;

                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <TextField
                            label={translations['email'] || 'Email'}
                            placeholder={translations['email'] || 'Email'}
                            name="Email"
                            fullWidth={true}
                            value={values.Email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            margin="dense"
                            error={!!(errors.Email && touched.Email)}
                        />
                        <FormControl className={classes.formControl} margin={"dense"}>
                            <Autocomplete
                                options={withBrowserLanguageOnTop(appTranslations || [])}
                                groupBy={option => option.__group}
                                getOptionLabel={option => option.displayName || ''}
                                getOptionSelected={(option, val) => option.code === val.code}
                                value={
                                    (appTranslations || []).find(
                                        o => o.code === (values.language || detectBrowserLanguageCode() || 'en')
                                    ) || null
                                }
                                onChange={(_event, option) => {
                                    const code = option ? option.code : 'en';
                                    setFieldValue('language', code);
                                    if (handleLanguageChange) handleLanguageChange({ target: { value: code } });
                                }}
                                renderGroup={params => [
                                    params.group === 'All languages' && (
                                        <Divider key={`${params.key}-divider`} component="li" />
                                    ),
                                    <ul key={params.key} style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                        {params.children}
                                    </ul>
                                ]}
                                disableClearable
                                blurOnSelect
                                fullWidth
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        name="language"
                                        label={translations['language'] || 'Select language'}
                                        margin="dense"
                                    />
                                )}
                            />
                        </FormControl>
                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                fullWidth={true}
                                disabled={isSubmitting || !(isValid && dirty)}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>
                        ) : null}

                    </form>
                );
            }}
        </Formik>
    );
}

export default withStyles(styles, { withTheme: true })(EmailAuthenticationForm);
